var obj = {
  title:['企效云','Qi Xiao Yun'],
  home: ['首页', 'Home'],
  product: ['产品', 'Product'],
  solution: ['解决方案', 'Solution'],
  support: ['支持与服务', 'Support&Service'],
  partners: ['合作伙伴与生态', 'Partners&Ecology'],
  corporate: ['企业新闻', 'Corporate News'],
  news: ['新闻详情', 'News detail'],
  about: ['关于我们', 'About Us'],
  contact: ['联系我们', 'Contact us'],
  terms: ['使用条款', 'Terms of Use'],
  privacy: ['隐私政策', 'Privacy Policy'],
  access: ['接入流程', 'Access Process'],
  customer: ['客服中心', 'Customer center'],
  footText: [
    '昀活科技旗下拥有完善的产品矩阵和解决方案，其中，企效云是专注于酒旅行业的saas软件服务品牌，以新兴科技优化酒店企业业务流程，有效提高企业运营效率。',
    'Shanghai Yunhuo Network Technology Co., Ltd has a complete product matrix and solutions. QiXiaoYun is a saas software service brand focusing on the hospitality industry, optimizing the business processes of hotel enterprises with emerging technologies and effectively improving the operational efficiency of enterprises. ',
  ],
  foot1: [
    '© 2014-2020 上海昀活网络科技有限公司. 保留所有权利.',
    '© 2014-2020 Shanghai Yunhuo Network Technology Co., Ltd All rights reserved',
  ],
  foot2: ['沪ICP备18001015号-6', 'Hu ICP Bei No. 18001015-6'],
  fast: ['快速入口', 'Quick entrance'],
  problem: ['常见问题', 'FAQ'],
  address: [
    '上海市徐汇区\n天钥桥路333号腾飞大厦4F',
    'Xuhui District, Shanghai4F, Tengfei Building, 333 Tianyaoqiao Road',
  ],
  tel: ['电话', 'Tel'],
  understand: ['了解企效云', 'Learn about Qi Xiao Yun'],
  understandText: [
    '上海昀活网络科技有限公司创立于2014年，是一家技术与服务驱动的企业数字化云服务商。',
    'Shanghai Yunhuo Network Technology Co., Ltd., founded in 2014, is a technology and service-driven enterprise digital cloud service provider.',
  ],
  establish: ['公司成立', 'Establishment of the Company'],
  customers: ['服务客户超过300家', 'Serving more than 300 customers'],
  orders: ['100万+', '1 million+'],
  ordersText: [
    '累计交易订单数超100万单',
    'The cumulative number of transaction orders exceeds 1 million',
  ],
  money: ['5亿+', '500 million+'],
  moneyText: [
    '累计交易金额超5亿元',
    'The accumulated transaction amount exceeds 500 million yuan',
  ],
  enterprise: [
    '文旅数字运营解决方案',
    'Enterprise Digital Operation Solutions',
  ],
  enterpriseText: [
    '昀活科技旗下拥有完善的产品矩阵和解决方案，其中，企效云是专注于酒旅行业的saas软件服务品牌，以新兴科技优化酒店企业业务流程，有效提高企业运营效率。',
    'Shanghai Yunhuo Network Technology Co., Ltd has a complete product matrix and solutions. QiXiaoYun is a saas software service brand focusing on the hospitality industry, optimizing the business processes of hotel enterprises with emerging technologies and effectively improving the operational efficiency of enterprises.',
  ],
  moreProducts: ['查看更多产品', 'View more products'],
  solutions: ['热门方案', 'Popular solutions'],
  solutionsText1: [
    '我们为不同酒店和景区类型提供会员方案和全员营销整体方案。',
    'We provide membership programs and overall marketing programs for different types of hotels and scenic spots.',
  ],
  solutionsText2: [
    '针对第三方服务商，我们可以提供技术对接服务。',
    'For third-party service providers, we can provide technology docking services.',
  ],
  moreSolutions: ['查看更多方案', 'View more scenarios'],
  solutions1: ['度假型酒店解决方案', 'Resort Hotel Solutions'],
  solutions1Text: [
    '主打票券预售，全员分销等',
    'Mainly focus on ticket pre-sale, all-member distribution, etc.',
  ],
  solutions2: ['商务酒店解决方案', 'Business Hotel Solutions'],
  solutions2Text: [
    '主打协议订房，会员订房，客房餐饮等',
    'Mainly focus on membership management, ticket booking, catering booking, ticket pre-sale, etc.',
  ],
  solutions3: ['会议型酒店解决方案', 'Conference Hotel Solutions'],
  solutions3Text: [
    '主打团体订房，会议厅管理，协议订房等',
    'Mainly focus on agreement room booking, member room booking, room catering, etc.',
  ],
  solutions4: ['景区集团解决方案', 'Scenic Area Group Solutions'],
  solutions4Text: [
    '主打会员，门票预订，餐饮预订，票券预售等',
    'Mainly focus on group room booking, conference hall management, agreement room booking, etc.',
  ],
  solutions5: ['酒店企业客户解决方案', 'Hotel Corporate Customer Solution'],
  solutions5Text: [
    '协议订房，积分商城等功能组合',
    'Agreement room booking, points mall and other functional combinations.',
  ],
  solutions6: [
    'PMS等第三方系统对接解决方案',
    'PMS and other third-party system docking Solution',
  ],
  solutions6Text: [
    'PMS，景区闸机，停车系统等对接',
    'PMS, scenic gates, parking systems and other docking.',
  ],
  solutions7: ['酒店餐饮解决方案', 'Hotel Catering Solutions'],
  solutions7Text: [
    '客房送餐，堂食，外卖配送等功能组合',
    'Room delivery, in-room food, take-out delivery and other functional combinations.',
  ],
  solutions8: [
    '酒景文旅综合体解决方案',
    'Hotel Scenic Cultural Tourism Complex Solution',
  ],
  solutions8Text: [
    '会员，商城，预售，拼团等营销功能组合',
    'Membership management, shopping mall, pre-sale, group buying and other function combinations.',
  ],
  solutions9: ['酒店集团解决方案', 'Hotel Group Solutions'],
  solutions9Text: [
    '多门店，票券，预售等功能组合',
    'Multi-store, ticket, pre-sale and other functional combinations',
  ],
  step1: [
    '根据企业类型和特点，选择合适解决方案',
    'Select the appropriate solution according to the type and characteristics of the enterprise',
  ],
  step2: ['签订合同，开始接入', 'Sign the contract and start accessing.'],
  step3: [
    '系统配置，以适合企业之需',
    'Configure the system to suit the needs of the enterprise.',
  ],
  step4: ['立即使用，开始数字化运营', 'Use it now and start digital operation'],
  step1Text: [
    '不同酒店类型可选择不同的产品搭配组合',
    'Different product combinations can be selected for different hotel types',
  ],
  step2Text: [
    '和YeaHotel商务经理签订服务合同，确定接入',
    'Sign the service contract with the business manager of Qi Xiao Yun to determine the access.',
  ],
  step3Text: [
    'YeaHotel运维经理全程辅助接入配置，一周左右即可上线',
    'The operation and maintenance manager of Qi Xiao Yun will be responsible for the whole access configuration, and it will be online in about a week.',
  ],
  step4Text: [
    '包括电脑端和App端的完善的管理后台，数字化运营so easy~',
    'You can manage the background in two terminals, computer side and APP side, and easily realize digital operation.',
  ],
  successCases: ['成功案例', 'Successful Cases'],
  successCasesText: [
    '我们已服务超300家酒店景区企业',
    'We have served more than 300 hotels and scenic spot enterprises.',
  ],
  zhongan: [
    '杭州临安众安氡温泉度假酒店',
    "Hangzhou Lin'an Zhong'an Radon Hot Spring Resort Hotel",
  ],
  zhonganText: [
    '度假型酒店，主要使用票券预售，全员营销，储值卡等产品。',
    'Resort hotels, mainly using products such as ticket pre-sales, integrating marketing, stored value cards, etc.',
  ],
  fuyue: ['上海富悦大酒店', 'Shanghai Fuyue Hotel'],
  fuyueText: [
    '会议型酒店，主要使用团体订房，会议厅管理系统，协议订房等产品。',
    'Conference hotel, mainly using group room booking, conference hall management system, agreement room booking and other products.',
  ],
  sunhe: ['舜和集团', 'Shunhe Group'],
  sunheText: [
    '重餐饮的商务型酒店集团，主要使用餐饮外卖，客房送餐，会员，全员营销等功能。',
    'The business hotel group that focuses on catering mainly uses the functions of catering takeaway, room delivery, membership management, and integrating marketing.',
  ],
  yuanxiang: ['原乡文旅', 'Yuanxiang Cultural Tourism'],
  yuanxiangText: [
    '酒景综合体，主要使用商城，拼团，会员，票券预售，门票售卖等功能。',
    'Hotel scenic complex, mainly using the shopping mall, group buying, membership management, ticket pre-sale, ticket sales, etc.',
  ],
  access18: ['2018年接入', 'Access in 2018'],
  access19: ['2019年接入', 'Access in 2019'],
  contactUs: ['立即联系我们，享免费试用', 'Contact us now for a free trial'],
  contactUsText: [
    '免费试用餐饮外卖，客房送餐，客房预订，全员营销等多款核心云产品，开启您的0门槛上云之旅！',
    'Free trial of a many core cloud products such as catering takeaway, room delivery, room reservation, integrating marketing, etc., easily enjoy the digital transformation!',
  ],
  applyNow: [
    '立刻申请成为企效云伙伴',
    'Apply to become a partner of Qi Xiao Yun immediately',
  ],
  training: ['培训与认证', 'Training and certification'],
  trainingText: [
    '合作伙伴培训课程可以帮助合作伙伴了解云产品知识、提高技能、让其业务脱颖而出并更好地服务客户',
    "Partner training courses help partners understand products’ knowledge, improve skills, differentiate their business and better serve customers.",
  ],
  curriculum1: ['云产品课程', 'Cloud product courses'],
  curriculum2: ['解决方案课程', 'Solution Course'],
  curriculum3: ['运维课程', 'Operations and Maintenance Course'],
  curriculum4: ['岗位与认证培训', 'Job and Certification Training'],
  curriculum1Text: [
    '帮助合作伙伴了解云产品基础知识，使用场景等。',
    'Helps partners understand cloud product basics, usage scenarios, etc.',
  ],
  curriculum2Text: [
    '帮助合作伙伴了解解决方案基础知识，使用场景等。',
    'Help partners understand solution basics, usage scenarios, etc.',
  ],
  curriculum3Text: [
    '帮助合作伙伴了解客户接入，运维等基础知识等。',
    'Help partners understand the basics of customer access, operation and maintenance, etc.',
  ],
  curriculum4Text: [
    '帮助合作伙伴了解云产品基础知识，使用场景等。',
    'Help partners understand cloud product basics, usage scenarios, etc.',
  ],
  updated22: ['2022年2月更新', 'Updated in February 2022'],
  serviceModes: [
    '对每一家接入的客户我们都提供如下几种服务方式：',
    'We provide the following service modes for each connected customer:',
  ],
  serviceMode1: [
    '微信专属一对一对接群',
    'WeChat exclusive one-to-one docking group',
  ],
  serviceMode2: [
    '客户中心，包括视频，图片，文字等使用教程',
    'Customer center, including video, pictures, text and other use tutorials',
  ],
  serviceMode3: ['客服电话', 'customer service telephone numbers'],
  serviceMode4: ['客房操作设置', 'Room operation settings'],
  serviceMode5: ['首页装修设置', 'Home decoration setting'],
  serviceMode6: ['小程序码生成', 'Applet code generation'],
  serviceMode7: ['更多常见问题', 'More FAQs'],
  viewDetails: ['查看详情', 'View details'],
  product1: ['会员与忠诚度计划', 'Membership and Loyalty Program'],
  product2: ['全员营销', 'Integrating Marketing'],
  product3: ['餐厅点餐/外卖/迷你吧', 'Restaurant order/takeout/mini bar'],
  product4: ['协议订房', 'Agreement Booking'],
  product5: ['团体订房', 'Group Booking'],
  product6: ['门票预订', 'Ticket Booking'],
  product7: ['商城', 'Shopping Mall'],
  product8: ['票券预售', 'Ticket pre-sale'],
  product9: ['储值卡', 'Stored-value card'],
  product1Text: [
    '帮助酒店建立完善的会员体系',
    'Helping hotels establish perfect membership system.',
  ],
  product2Text: [
    '全员营销，助力酒店拓展销售体系',
    'Integrating marketing, helping hotels to expand sales system.',
  ],
  product3Text: [
    '堂食/客房送餐/外卖，全方位解决客人用餐',
    "In-room food/room delivery/takeaway, all-round solution for guests' dining.",
  ],
  product4Text: [
    '协议客户在线预订',
    'Online reservation of agreement customers',
  ],
  product5Text: [
    '团体自付费订房，无需接电话，自主预订',
    'Group self-pay room reservation, no need to answer the phone, self-booking',
  ],
  product6Text: [
    '景区门票，在线预订',
    'Tickets for scenic spots, online reservation',
  ],
  product7Text: [
    '支持秒杀，多规格选择等',
    'Support seckill, multi-specification selection, etc',
  ],
  product8Text: ['优惠活动', 'Promotions.'],
  product9Text: ['线上线下打通', 'Connecting online and offline scenes.'],
  productDescription: ['产品描述', 'Product description'],
  productScreenshot: ['产品截图', 'Product screenshot'],
  productFeatures: ['产品特点', 'Product features'],
  productDescription1: [
    '酒店会员忠诚度计划包括会员等级，积分，储值等功能模块。',
    'The hotel member loyalty plan includes functional modules such as member level, points, and stored value.',
  ],
  productDescription2: [
    '注册会员方式支持手机号注册，购买身份和储值等多种方式，不同等级可以享受不同积分和价格优惠。',
    'The member registration method supports mobile phone number registration, purchase identity and stored value, and different grades can enjoy different points and price concessions.',
  ],
  productDescription3: [
    '支持积分商城商品兑换，支持全积分兑换，积分➕现金兑换等多种方式。',
    'Support point shopping mall commodity exchange, support full point exchange, points ➕ Cash exchange and other ways.',
  ],
  productDescription4: [
    '会员储值余额可用于订房，点餐，购买商品等多种消费场景。',
    "The balance of the member's stored value can be used for a variety of consumption scenarios such as room reservation, meal order, and commodity purchase.",
  ],
  productDescription5: [
    '全员营销基于微信社交流量和会员，酒店员工等的全员分享，拓展酒店销售体系。',
    'Full marketing is based on WeChat social traffic and full sharing of members, hotel staff, etc., to expand the hotel sales system.',
  ],
  productDescription6: [
    '支持无需申请的方式和仅酒店内部员工参与两种分销模式。',
    'It supports two distribution modes: no application and only internal employees of the hotel.',
  ],
  productDescription7: [
    '分销金发放支持微信和支付宝两种支付渠道。',
    'Distribution gold distribution supports WeChat and Alipay.',
  ],
  productDescription8: [
    '支持客房，餐饮，商品，门票等多种消费项目的分销。',
    'Support the distribution of various consumption items such as rooms, catering, commodities, tickets, etc.',
  ],
  productDescription9: [
    '该功能主要解决客人餐饮预订功能，客人直接线上或扫码点餐，酒店通过电脑，YeaHotel App，小票打印机等多种方式接单。',
    'This function is mainly used to solve the catering reservation function of guests. Guests can order meals directly online or by scanning code. The hotel can use the computer, YeaHotel',
  ],
  productDescription10: [
    '对堂食/外带，客房送餐，外卖配送/到店自提等多种订餐方式做了针对性优化，最大化提升客户消费体验。',
    'Targeted optimization has been made for various ordering methods, such as in-room food/take-out, room delivery, take-out delivery/in-store delivery, to maximize customer consumption experience.',
  ],
  productDescription11: [
    '支持对接第三方方配送平台，包括达达，美团配送等。',
    'Support the docking of third-party distribution platforms, including Dada and Meituan distribution.',
  ],
  productDescription12: [
    '协议订房提供商务酒店企业客户线上预订流程，从单位签约，预订人管理，协议价配置等提供全方位的支持。',
    'Agreement booking provides online booking process for business hotel enterprise customers, providing all-round support from unit signing, reservation management, agreement price configuration, etc.',
  ],
  productDescription13: [
    '协议客线上化可有效规避人工服务水平难以保障，从而降低客户流失率。',
    'Online agreement customers can effectively avoid the difficulty of ensuring the level of manual service, thus reducing the customer churn rate.',
  ],
  productDescription14: [
    '酒店可控制协议订房入口的开放程度，针对不同等级客户，享受不同协议价格。',
    'The hotel can control the openness of the entrance to the agreement room and enjoy different agreement prices for different levels of customers.',
  ],
  productDescription15: [
    '团体订房解决酒店包会不包房的客户，自付费客人的订房问题。',
    'Group room reservation can solve the problem of room reservation for self-paying guests who do not have room reservation.',
  ],
  productDescription16: [
    '酒店可根据不同会议设置不同预订价格和客房数量。',
    'The hotel can set different reservation rates and number of rooms according to different meetings.',
  ],
  productDescription17: [
    '客人扫码直接预订，无需通过电话和销售确定预订房型，价格和日期等。',
    'Customers can book directly by scanning the code, without having to confirm the room type, price and date through telephone and sales.',
  ],
  productDescription18: [
    '门票预订适合景区，含娱乐项目的度假酒店等，可对接国内主流闸机系统，包括智游宝，票付通，捷成安等。',
    "Ticket booking is suitable for scenic spots, resort hotels with entertainment items, etc., which can be connected with domestic mainstream gate systems, including Zhiyoubao, TicketPay, Jiecheng'an, etc.",
  ],
  productDescription19: [
    '客人线上预订门票，线下扫码入园，全程数字化，降低酒店管理和运维成本。',
    'Guests book tickets online, scan the code offline and enter the park, digitize the whole process, and reduce the cost of hotel management and operation and maintenance.',
  ],
  productDescription20: [
    '支持普通客人预订和协议客人预订等，不同身份不同价格。',
    'Support ordinary guest reservation and agreement guest reservation, and different prices for different identities.',
  ],
  productDescription21: [
    '商城支持多种价格模式，秒杀，阶梯价等。',
    'The mall supports a variety of price models, such as seckill and ladder price.',
  ],
  productDescription22: [
    '支持到店自提和快递配送等多种模式。',
    'It supports various modes such as self-delivery and express delivery.',
  ],
  productDescription23: [
    '可绑定票券，刺激相关产品消费等。',
    'It can bind tickets to stimulate the consumption of related products.',
  ],
  productDescription24: [
    '票券预售适合酒店在特定时期，节假日，店庆等做营销活动。',
    'The pre-sale of tickets is suitable for the marketing activities of the hotel in specific periods, holidays, store celebrations, etc.',
  ],
  productDescription25: [
    '可支持房券，餐券等多种消费项目。',
    'It can support a variety of consumption items such as room vouchers and meal vouchers.',
  ],
  productDescription26: [
    '可单个销售，也可打包销售，售出票券可直接在线消费。',
    'It can be sold individually or in packages. The tickets sold can be consumed directly online.',
  ],
  productDescription27: [
    '储值卡提供储值业务支持，可以和线下实体卡同步，线下刷卡和线上消费数据统一管理。',
    'Stored value cards provide stored value business support, which can be synchronized with offline physical cards, and offline swiping and online consumption data can be managed uniformly.',
  ],
  productDescription28: [
    '支持线上预订客房，购买商品，点餐等多种消费项目和场景。',
    'It supports online reservation of rooms, purchase of goods, ordering of meals and other consumption items and scenarios.',
  ],
  productDescription29: [
    '支持设置不同充值金额。',
    'Different recharge amounts can be set.',
  ],

  productFeatures1: [
    '完善的会员管理体系。',
    'Perfect member management system.',
  ],
  productFeatures2: [
    '针对酒旅行业场景，优化会员在客房预订，餐饮消费，门票预订等场景的消费体验。',
    'Optimize the consumption experience of members in room booking, catering consumption, ticket booking and other scenarios for the wine and tourism industry.',
  ],
  productFeatures3: [
    '会员支持在线消费和线下扫码扣款，消费过程数字化，降低管理成本。',
    'Members support online consumption and offline code scanning deduction, digitize the consumption process and reduce management costs.',
  ],
  productFeatures4: [
    '灵活的分销金设置方式。',
    'Flexible distribution fund setting method.',
  ],
  productFeatures5: [
    '最多支持两级分销，满足微信生态场景合规经营。',
    'Support at most two levels of distribution to meet the compliance operation of WeChat ecological scenario.',
  ],
  productFeatures6: [
    '支持每月分批发放分销金和实时发放分销金等多种发放方式。',
    'It supports multiple distribution methods such as monthly distribution payment in batches and real-time distribution payment.',
  ],
  productFeatures7: [
    '完善的分销报表导出功能。',
    'Perfect distribution report export function.',
  ],
  productFeatures8: [
    '针对多种点餐场景做针对性优化。',
    'Make targeted optimization for various ordering scenarios.',
  ],
  productFeatures9: [
    '支持第三方小票打印机，例如易联云，飞鹅云等。',
    'Support third-party ticket printers, such as Yilianyun, Feigeyun, etc.',
  ],
  productFeatures10: [
    '完善的报表导出和菜品热度分析等。',
    'Perfect report export and dish heat analysis.',
  ],
  productFeatures11: [
    '协议客户扫码绑定身份后，即可自助订房，无需人工服务。',
    'After the agreement customers scan the code and bind their identities, they can book their rooms by themselves without manual service.',
  ],
  productFeatures12: [
    '协议客户线上维护，酒店销售人员离职不会导致客户流失。',
    'Online maintenance of agreed customers. The departure of hotel sales staff will not lead to customer loss.',
  ],
  productFeatures13: [
    '支持完善的销售业绩报表。',
    'Support complete sales performance report.',
  ],
  productFeatures14: [
    '同一房型，不同会议可设置不同价格和数量。',
    'For the same room type, different prices and quantities can be set for different meetings.',
  ],
  productFeatures15: [
    '客人直接扫码支付，降低流失率，最大程度提前回款。',
    'Customers can directly scan the code to pay, reduce the loss rate and maximize the advance payment.',
  ],
  productFeatures16: [
    '支持同一参会客人，相同性别可半价拼房，最大程度增加收入来源。',
    'Support the same guests, the same gender can share the room at half price, and maximize the source of income.',
  ],
  productFeatures17: [
    '完善的预订报表导出。',
    'Complete reservation report export.',
  ],
  productFeatures18: [
    '直连闸机系统，从买票到入园，无需人工干预。',
    'Directly connected gate system, no manual intervention is required from ticket purchase to admission.',
  ],
  productFeatures19: [
    '支持不同会员身份不同价格，优化客人消费体验。',
    'Support different membership and different prices to optimize guest consumption experience.',
  ],
  productFeatures20: [
    '支持分销，可基于微信社交流量拓展销售体系。',
    'Support distribution and expand the sales system based on WeChat social traffic.',
  ],
  productFeatures21: [
    '可绑定票券，刺激相关产品消费等。',
    'It can bind tickets to stimulate the consumption of related products.',
  ],
  productFeatures22: [
    '支持显示视频，图文并茂展示商品，增大成交概率。',
    'Support the display of video and illustrated display of goods to increase the transaction probability.',
  ],
  productFeatures23: [
    '支持分销功能，酒店可以基于社交流量拓展销售渠道。',
    'Support the distribution function. The hotel can expand its sales channels based on social traffic.',
  ],
  productFeatures24: [
    '支持全员分销，最大化增加销售额。',
    'Support full distribution and maximize sales.',
  ],
  productFeatures25: ['完善的报表导出。', 'Perfect report export.'],
  productFeatures26: [
    '支持线上售卖和线下售卖两种方式。',
    'Support online sales and offline sales.',
  ],
  productFeatures27: [
    '支持分销，最大化增加交易额。',
    'Support distribution and maximize transaction volume.',
  ],
  productFeatures28: [
    '客人购买后可以转赠，实现礼品卡功能。',
    'Guests can transfer gifts after purchase to realize the gift card function.',
  ],
};
// localStorage.setItem('lan', 0);
var lan = localStorage.getItem('lan') || 0;
var index = localStorage.getItem('lan') || 0;
var language = document.getElementsByClassName('language');
Array.from(language).forEach((e) => {
  e.innerText = obj[e.getAttribute('value')][index];
});
function languageChange() {
  var lan = localStorage.getItem('lan');
  if (lan == 0) {
    localStorage.setItem('lan', 1);
    index = 1;
  } else {
    localStorage.setItem('lan', 0);
    index = 0;
  }
  var language = document.getElementsByClassName('language');
  Array.from(language).forEach((e) => {
    e.innerText = obj[e.getAttribute('value')][index];
  });
}
